import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/copy.svg'


const _withScopeId = n => (_pushScopeId("data-v-4eb32ff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tracking-link" }, "Tracking Link Input", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "error-transaction"
}
const _hoisted_4 = {
  key: 2,
  class: "p-d-flex link-text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-pb-4 p-pl-3"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"20rem"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.showAddInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_InputText, {
            class: "tittle-input",
            type: "text",
            modelValue: _ctx.url,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.url) = $event)),
            placeholder: "Input tracking link",
            style: {"width":"20%"}
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            style: {"color":"#E0010B","margin-left":"30px"},
            label: "SAVE LINK",
            class: "edit-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showAddInput = false; _ctx.showEditLink = true; _ctx.saveUrl()})
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.url?.length > 1 && !_ctx.url.includes('{transactionid}'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Your link is missing {transaction id}, which may cause problems with conversion tracking. "))
      : _createCommentVNode("", true),
    (_ctx.showEditLink)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "p-d-flex link-text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyLink(_ctx.campaign?.trackingLink)))
          }, [
            _createTextVNode(_toDisplayString(_ctx.campaign?.trackingLink) + " ", 1),
            _hoisted_5
          ]),
          _createVNode(_component_Button, {
            disabled: _ctx.loadingSaveLink,
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.showEditLink = !_ctx.showEditLink; _ctx.showAddInput= true;}),
            class: "edit-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" EDIT LINK "),
              (_ctx.loadingSaveLink)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}